<template>
  <div>
    <v-menu 
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="200"
    >
      <template v-slot:activator="{ on }">
        <v-btn 
          icon 
          v-on="on"
        >
          <v-icon color="white">
            mdi-delete
          </v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-card-text> Are you sure you want to delete this?</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            :disabled="progressing"
            text
            class="px-10"
            @click="menu = false"
          >
            No
          </v-btn>
          <v-btn
            :loading="progressing"
            color="hrissecondary"      
            class="white--text px-10"     
            @click="submitForm"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>

    <v-dialog
      v-model="confirmationDialog"
      max-width="500"
    >
      <v-card>
        <v-card-title />

        <v-card-text>
          {{ leaveEntitlementMessage }}
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            text
            @click="confirmationDialog = false"
          >
            Cancel
          </v-btn>

          <v-btn
            color="primary"
            @click="confirmDelete"
          >
            Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    props: {
      separation: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        menu: null,
        progressing: false,
        confirmationDialog: false,
        leaveEntitlementMessage: '',
      }
    },
    methods: {
      submitForm () {
        this.progressing = true

        this.$api.hrisEmployeeSeparations().delete(this.separation.id)
          .then(response => {
            if (response.status === 200) {
              this.$emit('deleted')
              this.$snack({ message: response.data.status })

              this.progressing = false
              this.menu = false
            }
          })
          .catch((error) => {
            if (error.response.status === 405) {
              this.progressing = false
              this.menu = false

              this.$dialog({
                title: 'Unable to resign',
                message: error.response.data.status,
                color: 'error',
              })
            } else if (
              error.response.status === 409 &&
              error.response.data.status === 'confirmation_required'
            ) {
              this.progressing = false
              this.menu = false

              this.leaveEntitlementMessage = error.response.data.message
              this.confirmationDialog = true
            }
          })
      },
      confirmDelete () {
        this.progressing = true

        this.$api.hrisEmployeeSeparations().delete(
          this.separation.id,
          {
            params: {
              confirm_leave_entitlement: true,
            },
          }
        )
          .then(response => {
            if (response.status === 200) {
              this.$emit('deleted')
              this.$snack({ message: response.data.status })

              this.confirmationDialog = false
              this.menu = false
            }
          })
          .catch(error => {
            this.$snack({
              message: error.response.data.message || 'Unable to delete',
              color: 'error',
            })
          })
          .finally(() => {
            this.progressing = false
          })
      },
    },
  }
</script>
